import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1] as const;

const PageLoader: React.FC = () => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      bgcolor: "#f8f9fb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    }}
  >
    <Box sx={{ position: "relative", width: 200, height: 40 }}>
      {/* Vertical centre line */}
      <motion.div
        animate={{ scaleY: [0, 1, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease, times: [0, 0.2, 0.8, 1] }}
        style={{
          position: "absolute", left: "50%", top: 0,
          width: 1, height: "100%",
          backgroundColor: "rgba(29,47,65,0.25)",
          transformOrigin: "top",
        }}
      />
      {/* Left horizontal line */}
      <motion.div
        animate={{ scaleX: [0, 1, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease, times: [0, 0.3, 0.8, 1], delay: 0.15 }}
        style={{
          position: "absolute", top: "50%", right: "calc(50% + 6px)",
          width: "calc(50% - 6px)", height: 1,
          backgroundColor: "rgba(29,47,65,0.2)",
          transformOrigin: "right",
        }}
      />
      {/* Right horizontal line */}
      <motion.div
        animate={{ scaleX: [0, 1, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease, times: [0, 0.3, 0.8, 1], delay: 0.15 }}
        style={{
          position: "absolute", top: "50%", left: "calc(50% + 6px)",
          width: "calc(50% - 6px)", height: 1,
          backgroundColor: "rgba(29,47,65,0.2)",
          transformOrigin: "left",
        }}
      />
    </Box>
  </Box>
);

export default PageLoader;
